<template lang="pug">
    ib-dropdown(:data="currency", v-model="cur", @change="onChange($event)", :placeholder="$t('select_currency')")
</template>

<script>

    export default {
        name: 'ChangeCurrency',

        props: ['currs'],

        data() {
            return {
                currency: [
                    { label: this.$t('select_usd'), value: "USD" },
                    { label: this.$t('select_aud'), value: "AUD" },
                    { label: this.$t('select_brl'), value: "BRL" },
                    { label: this.$t('select_gbp'), value: "GBP" },
                    { label: this.$t('select_bgn'), value: "BGN" },
                    { label: this.$t('select_cad'), value: "CAD" },
                    { label: this.$t('select_cnh'), value: "CNH" },
                    { label: this.$t('select_cny'), value: "CNY" },
                    { label: this.$t('select_hrk'), value: "HRK" },
                    { label: this.$t('select_czk'), value: "CZK" },
                    { label: this.$t('select_dkk'), value: "DKK" },
                    { label: this.$t('select_eur'), value: "EUR" },
                    { label: this.$t('select_hkd'), value: "HKD" },
                    { label: this.$t('select_huf'), value: "HUF" },
                    { label: this.$t('select_inr'), value: "INR" },
                    { label: this.$t('select_ils'), value: "ILS" },
                    { label: this.$t('select_jpy'), value: "JPY" },
                    { label: this.$t('select_mxn'), value: "MXN" },
                    { label: this.$t('select_nok'), value: "NOK" },
                    { label: this.$t('select_nzd'), value: "NZD" },
                    { label: this.$t('select_pln'), value: "PLN" },
                    { label: this.$t('select_ron'), value: "RON" },
                    { label: this.$t('select_sar'), value: "SAR" },
                    { label: this.$t('select_sgd'), value: "SGD" },
                    { label: this.$t('select_krw'), value: "KRW" },
                    { label: this.$t('select_sek'), value: "SEK" },
                    { label: this.$t('select_chf'), value: "CHF" },
                    { label: this.$t('select_zar'), value: "ZAR" },
                    { label: this.$t('select_twd'), value: "TWD" },
                    { label: this.$t('select_try'), value: "TRY" },
                    { label: this.$t('select_uae'), value: "AED" }
                ],
                cur: "",
            }
        },
        mounted() {
            if (this.currs) {
                this.cur = this.currs;
            } else {
                this.cur = 'USD';
            }
        },
        methods: {
            onChange(event) {
                this.$emit('currency', this.cur);
            }
        }
    }
</script>